function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
}

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

function queryTerms(query) {
  return String(query || "")
    .match(/"([^"]+)"|'([^']+)'|(\S+)/g)
    ?.map(term => term.replace(/^["']|["']$/g, "").trim())
    .filter(Boolean)
    .slice(0, 10) || []
}

function digitMatchRanges(text, query) {
  const queryDigits = String(query || "").replace(/\D/g, "")
  if (queryDigits.length < 4) return []

  const digitPositions = []
  const textDigits = Array.from(String(text || "")).filter((character, index) => {
    if (/\d/.test(character)) {
      digitPositions.push(index)
      return true
    }

    return false
  }).join("")

  const start = textDigits.indexOf(queryDigits)
  if (start === -1) return []

  return [[digitPositions[start], digitPositions[start + queryDigits.length - 1] + 1]]
}

function textMatchRanges(text, query) {
  return queryTerms(query).flatMap(term => {
    if (term.length < 2) return []

    const ranges = []
    const pattern = new RegExp(escapeRegExp(term), "gi")
    let match

    while ((match = pattern.exec(String(text || ""))) !== null) {
      ranges.push([match.index, match.index + match[0].length])
    }

    return ranges
  })
}

function mergeRanges(ranges) {
  return ranges
    .sort(([a], [b]) => a - b)
    .reduce((merged, range) => {
      const previous = merged.at(-1)
      if (!previous || range[0] > previous[1]) {
        merged.push([...range])
      } else {
        previous[1] = Math.max(previous[1], range[1])
      }

      return merged
    }, [])
}

export function highlightQuery(text, query) {
  if (!query || text === null || text === undefined) return escapeHtml(text || "")

  const value = String(text)
  const ranges = mergeRanges([...digitMatchRanges(value, query), ...textMatchRanges(value, query)])
  if (!ranges.length) return escapeHtml(value)

  let html = ""
  let cursor = 0

  ranges.forEach(([start, end]) => {
    html += escapeHtml(value.slice(cursor, start))
    html += `<mark class="query-highlight">${escapeHtml(value.slice(start, end))}</mark>`
    cursor = end
  })

  html += escapeHtml(value.slice(cursor))
  return html
}
